// ============================================
// FILE: frontend/src/components/matching/MatchScoreIndicator.jsx
// PURPOSE: Visual display of match score as percentage
// ============================================

import { Progress } from '../ui/progress';

// ========================================
// MAIN COMPONENT
// ========================================

export function MatchScoreIndicator({ score = 0, size = 'default' }) {
  console.log('[MatchScoreIndicator] Rendering with score:', { score, size });

  // ========================================
  // HELPER FUNCTIONS
  // ========================================

  const getScoreColor = (scoreValue) => {
    console.log('[MatchScoreIndicator] Determining color for score:', scoreValue);

    if (scoreValue >= 95) return 'from-green-600 to-green-400';
    if (scoreValue >= 90) return 'from-green-500 to-green-300';
    if (scoreValue >= 85) return 'from-blue-600 to-blue-400';
    if (scoreValue >= 80) return 'from-blue-500 to-blue-300';
    return 'from-gray-500 to-gray-300';
  };

  const getScoreLabel = (scoreValue) => {
    console.log('[MatchScoreIndicator] Generating label for score:', scoreValue);

    if (scoreValue >= 95) return 'Excellent Match';
    if (scoreValue >= 90) return 'Great Match';
    if (scoreValue >= 85) return 'Good Match';
    if (scoreValue >= 80) return 'Potential Match';
    return 'Low Match';
  };

  const getSizeClasses = (sizeValue) => {
    console.log('[MatchScoreIndicator] Getting size classes for:', sizeValue);

    switch (sizeValue) {
      case 'small':
        return {
          container: 'gap-2',
          score: 'text-lg',
          label: 'text-xs'
        };
      case 'large':
        return {
          container: 'gap-4',
          score: 'text-3xl',
          label: 'text-sm'
        };
      default:
        return {
          container: 'gap-3',
          score: 'text-2xl',
          label: 'text-sm'
        };
    }
  };

  // ========================================
  // COMPUTED VALUES
  // ========================================

  const scoreColor = getScoreColor(score);
  const scoreLabel = getScoreLabel(score);
  const sizeClasses = getSizeClasses(size);

  console.log('[MatchScoreIndicator] Computed:', {
    scoreColor,
    scoreLabel
  });

  // ========================================
  // RENDER
  // ========================================

  return (
    <div className={`flex items-center ${sizeClasses.container}`}>
      {/* ========================================
          SCORE CIRCLE
          ======================================== */}
      <div
        className={`relative w-20 h-20 rounded-full bg-gradient-to-br ${scoreColor} flex items-center justify-center shadow-md`}
      >
        <div className="absolute inset-1 bg-white rounded-full flex items-center justify-center">
          <div className="text-center">
            <p className={`${sizeClasses.score} font-bold text-gray-900`}>
              {score}
            </p>
            <p className="text-xs font-semibold text-gray-600">%</p>
          </div>
        </div>
      </div>

      {/* ========================================
          LABEL AND PROGRESS
          ======================================== */}
      <div className="flex-1">
        <p className={`${sizeClasses.label} font-semibold text-gray-900 mb-2`}>
          {scoreLabel}
        </p>

        <Progress
          value={score}
          className="h-2"
          indicatorClassName={`bg-gradient-to-r ${scoreColor}`}
        />

        <p className="text-xs text-muted-foreground mt-1">
          {score}% compatibility match
        </p>
      </div>
    </div>
  );
}

// ========================================
// EXPORT
// ========================================

export default MatchScoreIndicator;